import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import { withTranslation } from "react-i18next";
import moment from "moment";
import { InputCheckbox } from "components";
import { DATE_FORMAT, ACCESSOR_SEARCH_BOX, TENANT_LICENSE_CODE } from "../../core/utils/constants";
import { Helper } from "../../core/utils";
import "./style.scss";

@inject("commonStore")
@observer
class SearchBox extends Component {

  constructor(props) {
    super(props);
    this.state = {
      registeredDate: moment().format(DATE_FORMAT.frontend_minus),
      toDate: moment().format(DATE_FORMAT.frontend_minus)
    };
  }

  onChange = (name, value) => {
    this.setState({
      [name]: value
    });
  };

  handleKeyPressForNumber = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    if (!/^\d*$/.test(keyValue)) {
      event.preventDefault();
    }
  }

  handleChangeFromYear = (e) => {
    const { commonStore: { tenantStore: { setFromYear } } } = this.props;
    const re = /^\d*$/;
    const val = e.currentTarget.value;
    if (re.test(val) && (val === "" || parseInt(val) <= 9999)) {
      setFromYear(val)
    }
  }

  handleChangeToYear = (e) => {
    const { commonStore: { tenantStore: { setToYear } } } = this.props;
    const re = /^\d*$/;
    const val = e.currentTarget.value;
    if (re.test(val) && (val === "" || parseInt(val) <= 9999)) {
      setToYear(val)
    }
  }

  render() {
    const {
      t,
      commonStore: {
        tenantStore: { fromYear, fromMonth, toYear, toMonth, active, renewalSpanMonth, renewalSpanYear,
          licenseEvaluation, licenseFull, setFromMonth, setToMonth, setActive, setRenewalSpanMonth, setRenewalSpanYear,
          setLicenseEvaluation, setLicenseFull,
        }
      }
    } = this.props;
    return <div className="admin-header row tenant-search-pannel">
      <div className="col-sm-12" style={{ height: "24px", lineHeight: "24px", display: "flex", padding: 0 }}>
        <label>{t("tenant.month_year")}</label>
        <input className="input-number" type="number"
          max="9999"
          value={fromYear}
          onKeyPress={this.handleKeyPressForNumber}
          onChange={(e) => { this.handleChangeFromYear(e) }} />
        <label>{t("tenant.year")}</label>
        <select className="slct-month" onChange={(e) => setFromMonth(e.currentTarget.value)} value={fromMonth}>
          {Helper.getMonths().map(e => <option key={e} value={e}>{e}</option>)}
        </select>
        <label>{t("tenant.month")}</label>
        <label className="sb-dp-separate">{t("tenant.between")}</label>
        <input className="input-number" type="number"
          max="9999"
          value={toYear}
          onKeyPress={this.handleKeyPressForNumber}
          onChange={(e) => { this.handleChangeToYear(e) }} />
        <label>{t("tenant.year")}</label>
        <select className="slct-month" onChange={(e) => setToMonth(e.currentTarget.value)} value={toMonth}>
          {Helper.getMonths().map(e => <option key={e} value={e}>{e}</option>)}
        </select>
        <label>{t("tenant.month")}</label>
        <InputCheckbox
          id={ACCESSOR_SEARCH_BOX.ACTIVE}
          type="checkbox"
          label={t("tenant.checkbox_active")}
          onChange={(e) => setActive(e.currentTarget.checked ? 'true' : 'false')}
          checked={active === 'true'}
        />
      </div>
      <div className="col-sm-12" style={{ height: "24px", lineHeight: "24px", display: "flex", paddingLeft: 0, paddingRight: 0, paddingTop: 10, paddingBottom: 10 }}>
        <label>{t("tenant.renewal_span")}</label>
        <InputCheckbox
          id={ACCESSOR_SEARCH_BOX.RENEWAL_SPAN_MONTH}
          type="checkbox"
          label={t("tenant.renewal_span_month")}
          onChange={(e) => setRenewalSpanMonth(e.currentTarget.checked ? 'true' : 'false')}
          checked={renewalSpanMonth === 'true'}
        />
        <InputCheckbox
          id={ACCESSOR_SEARCH_BOX.RENEWAL_SPAN_YEAR}
          type="checkbox"
          label={t("tenant.renewal_span_year")}
          onChange={(e) => setRenewalSpanYear(e.currentTarget.checked ? 'true' : 'false')}
          checked={renewalSpanYear === 'true'}
        />
        <label>{t("tenant.license")}</label>
        <InputCheckbox
          id={TENANT_LICENSE_CODE.EVALUATION}
          type="checkbox"
          label={t("tenant.license.evaluation")}
          onChange={(e) => setLicenseEvaluation(e.currentTarget.checked ? 'true' : 'false')}
          checked={licenseEvaluation === 'true'}
        />
        <InputCheckbox
          id={TENANT_LICENSE_CODE.FULL}
          type="checkbox"
          label={t("tenant.license.full")}
          onChange={(e) => setLicenseFull(e.currentTarget.checked ? 'true' : 'false')}
          checked={licenseFull === 'true'}
        />
      </div>
    </div>
  }
}

export default withTranslation()(SearchBox);
